// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__Nvl0T","subheader":"ReorderModal_subheader__17hGx","listWrap":"ReorderModal_listWrap__2A9mF"};